module.exports = __webpack_public_path__ + "img/jf_home_12.5f3438bf.jpg";